export const learningGoalsOptions = [
  {
    category: "Career Advancement",
    options: [
      "Get a Promotion",
      "Switch to a New Career",
      "Get Hired at a Tech Company",
      "Advance in Current Job Role",
      "Build Professional Network",
    ],
  },
  {
    category: "Skill Development",
    options: [
      "Learn Programming",
      "Improve Public Speaking",
      "Master a Foreign Language",
      "Enhance Creative Thinking",
      "Build Critical Thinking Skills",
    ],
  },
  {
    category: "Certifications & Degrees",
    options: [
      "Earn a Certificate",
      "Complete a Microdegree",
      "Prepare for a Certification Exam",
      "Fulfill Continuing Education Credits",
    ],
  },
  {
    category: "Personal Enrichment",
    options: [
      "Explore New Hobbies",
      "Learn to Play an Instrument",
      "Improve Health & Wellness",
      "Become Financially Literate",
      "Practice Mindfulness & Meditation",
    ],
  },
  {
    category: "Entrepreneurship",
    options: [
      "Start a New Business",
      "Learn How to Freelance",
      "Develop a Product or App",
      "Build a Personal Brand",
    ],
  },
  {
    category: "Academic Support",
    options: [
      "Prepare for School/College Exams",
      "Improve Academic Grades",
      "Supplement School Curriculum",
      "Understand Complex Topics Easily",
    ],
  },
  {
    category: "Technology & Tools",
    options: [
      "Learn AI & Machine Learning",
      "Master Excel or Google Sheets",
      "Get Comfortable with Coding",
      "Understand Cloud Platforms",
    ],
  },
];
